import type { PageSegmentLoadMetric } from '@atlassian/browser-metrics/page-segment-load';

import { createPageSegmentLoadMetric } from '@confluence/browser-metrics/entry-points/metricConfigs.ts';
import { END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY } from '@confluence/browser-metrics/entry-points/metric-keys.ts';

export const END_OF_PAGE_RECOMMENDATIONS_METRIC: PageSegmentLoadMetric =
	createPageSegmentLoadMetric({
		key: END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY,
	});
